import * as React from 'react';

import { Flex, useCompassTheme, Link } from '@circleci/compass';

import { LibContext } from '~/contexts/LibContext';

import { MarketingButton } from './MarketingButton';
import { outerTheme } from './styles';
import translations from './translations.json';

interface MobileMenuProps {
  children?: React.ReactNode;
}

export const MobileMenu = ({ children }: MobileMenuProps) => {
  const { user } = React.useContext(LibContext);
  const theme = useCompassTheme();
  const locale = 'en';

  return (
    <Flex
      flexDirection="column"
      bottom={0}
      backgroundColor={'white'}
      height={`calc(100vh - ${outerTheme.globals.mobileHeaderHeight}px)`}
      top={`${outerTheme.globals.mobileHeaderHeight}px`}
      width="100%"
      position="absolute"
      right={0}
      paddingX={'space16'}
      data-testid="header-mobile-menu"
    >
      <hr
        css={{
          border: 'none',
          borderTop: `1px solid ${theme.colors.n70}`,
          height: '0px',
          width: '100%',
          margin: `${theme.space.space24} 0`,
          marginTop: 0,
          marginBottom: theme.space.space24,
        }}
      />
      <div
        css={{
          overflowY: 'scroll',
        }}
      >
        {children && (
          <>
            {children}
            <hr
              css={{
                border: 'none',
                borderTop: `1px solid ${theme.colors.n70}`,
                height: '0px',
                width: '100%',
                margin: `${theme.space.space24} 0`,
                marginTop: theme.space.space24,
                marginBottom: theme.space.space24,
              }}
            />
          </>
        )}

        <div>
          {translations[locale].navbarLinks.map((link, index) => {
            return (
              <Link
                key={index}
                href={link.href}
                css={{
                  width: '100%',
                  display: 'block',
                  color: theme.colors.n900,
                  fontWeight: theme.fontWeights.regular,
                  paddingBottom: theme.space.space24,
                }}
                onClick={() => {
                  if (typeof window !== 'undefined' && window.analytics) {
                    window.analytics.track('navbarLink', {
                      link: link.text,
                      href: link.href,
                      location: 'header',
                    });
                  }
                }}
              >
                {link.text}
              </Link>
            );
          })}
        </div>
      </div>

      <div
        css={{
          marginTop: 'auto', // this will make sure the flex child is always at the bottom
          marginBottom: theme.space.space16,
        }}
      >
        <hr
          css={{
            border: 'none',
            borderTop: `1px solid ${theme.colors.n70}`,
            height: '0px',
            width: '100%',
            margin: `${theme.space.space24} 0`,
            marginTop: theme.space.space24,
            marginBottom: theme.space.space24,
          }}
        />
        <MarketingButton
          data-testid="mobile-cta-marketing-button"
          href={
            user
              ? translations[locale].loginButton.loggedIn.href
              : translations[locale].loginButton.loggedOut.href
          }
          css={{
            width: '100%',
          }}
        >
          {user
            ? translations[locale].loginButton.loggedIn.text
            : translations[locale].loginButton.loggedOut.text}
        </MarketingButton>
      </div>
    </Flex>
  );
};
